import PropTypes from 'prop-types';
import React from 'react';

import * as PagesUnion from '$pages/union';
import { Meta } from '$partials/global';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const UnionPage = (props) => {
    const Component = PagesUnion[props.data?.page?.__typename];

    return (
        <>
            <Meta
                description={props.data?.page?.searchDescription}
                domain={props.domain}
                image={props.data?.page?.listingImage}
                page={props.data?.page}
                title={props.data?.page?.__typename === 'Home' ? 'Uniplan' : null}
                url={props.data?.uri} />

            <Component {...props.data} />
        </>
    );
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

const propTypes = {
    data: PropTypes.shape({
        page: PropTypes.shape({
            __typename: PropTypes.string.isRequired,
            listingImage: PropTypes.object,
            searchDescription: PropTypes.string
        }),
        uri: PropTypes.string,
    }).isRequired,
    dev: PropTypes.bool,
    domain: PropTypes.string,
    language: PropTypes.object,
    timezone: PropTypes.string,
    userAgent: PropTypes.object
};

UnionPage.propTypes = propTypes;

export { UnionPage };

export default UnionPage;
